module.exports = __webpack_public_path__ + "img/UT0424.67414541.png";